export default __webpack_public_path__ + "static/media/harvest-access.b2b2bb4e.png";